import { useState } from "react";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";
import "./select.scss";

const Select = ({ title, width, padding, listData, setValue, selectedTitle, showAllSelect = true }) => {
    const [showSelect, setShowSelect] = useState(false);
    const [selectedValue, setSelectedValue] = useState(selectedTitle ? selectedTitle : title);

    const setSelectedValueHandler = (title, id) => {
        setSelectedValue(title);
        setValue(id);
        setShowSelect(false);
    };

    return (
        <div className="select" style={{ width: width }}>
            <div className="select__selected" style={{ padding: padding }} onClick={() => setShowSelect(!showSelect)}>
                <div className="select__selected-title">{selectedValue}</div>
                <img src={arrowIcon} alt="" className="select_selected-img" />
            </div>
            {showSelect && (
                <div className="select__dropdown">
                    {showAllSelect && (
                        <div className="select__dropdown-item" onClick={() => setSelectedValueHandler(title, 0)}>
                            Всі
                        </div>
                    )}
                    {listData.map((listItem) => {
                        return (
                            <div
                                className="select__dropdown-item"
                                key={listItem.id}
                                onClick={() => setSelectedValueHandler(listItem?.title || listItem.name, listItem.id)}
                            >
                                {listItem?.title || listItem.name}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Select;
